import React from "react";
import { tgIcon } from "../../../images";
import PsPricesDealsPage from "../../pages/pspricesDealsPage";

const btnClass =
  "mb-3 flex w-40 justify-center rounded-md bg-indigo-600 px-3 py-1.5 text-base font-semibold leading-6 text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600 md:mb-0";

function getBuyOnSiteUrl(region) {
  if (region === "us") {
    return "https://trendy-eng-shop.ru/store/playstation";
  }
  return "https://trendy-eng-shop.ru/playstation/shop";
}

function PlayStationDiscount() {
  return (
    <PsPricesDealsPage
      title="Скидки PlayStation"
      platforms="PS5"
      platformQuery="PS5"
      regions={[
        { value: "us", label: "США" },
        { value: "pl", label: "Польша" },
        { value: "in", label: "Индия" },
      ]}
      ymPath="/playstation-discount"
      renderButtons={(region) => (
        <div className="flex flex-col items-center gap-2 sm:flex-row sm:flex-wrap sm:justify-center lg:flex-nowrap">
          <a
            href={getBuyOnSiteUrl(region)}
            className={btnClass}
            target="_blank"
            rel="noreferrer"
          >
            Купить на сайте
          </a>
          <a
            href="https://t.me/trendy_psn_bot?start=ref-001"
            className={btnClass}
            target="_blank"
            rel="noreferrer"
            onClick={() =>
              window.ym?.(93997310, "reachGoal", "tgClickPlayStation")
            }
          >
            Купить в{" "}
            <img src={tgIcon} alt="TG" className="ml-2 h-4 w-4 sm:h-5 sm:w-5" />
          </a>
        </div>
      )}
    />
  );
}

export default PlayStationDiscount;
